// src/components/Footer.js
import React from 'react';
import { FaYoutube, FaInstagram, FaFacebook, FaTiktok, FaEnvelope, FaWhatsapp } from 'react-icons/fa';

// --- CONFIGURACIÓN DE WHATSAPP ---
// **TU NÚMERO DE TELÉFONO (+13054076280) SIN EL SIGNO +**
const WHATSAPP_NUMBER = "13054076280"; 
const WHATSAPP_CTA = `https://wa.me/${WHATSAPP_NUMBER}`; 


export default function Footer() {
    return (
        <footer style={{ 
            backgroundColor: '#2c3e50', // Azul oscuro profesional
            color: 'white', 
            padding: '30px 20px', 
            textAlign: 'center',
            marginTop: 'auto' // Esto asegura que el footer se quede abajo
        }}>
            <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
                
                {/* Redes Sociales */}
                <div style={{ marginBottom: '20px' }}>
                    <a href="https://www.youtube.com/@VimcarBroker" target="_blank" rel="noopener noreferrer" style={socialIconStyle}>
                        <FaYoutube />
                    </a>
                    <a href="https://www.instagram.com/VimcarBroker" target="_blank" rel="noopener noreferrer" style={socialIconStyle}>
                        <FaInstagram />
                    </a>
                    <a href="https://www.facebook.com/VimcarBroker" target="_blank" rel="noopener noreferrer" style={socialIconStyle}>
                        <FaFacebook />
                    </a>
                    <a href="https://www.tiktok.com/@VimcarBroker" target="_blank" rel="noopener noreferrer" style={socialIconStyle}>
                        <FaTiktok />
                    </a>
                    <a href={`mailto:VIMCARBROKER@GMAIL.COM`} style={socialIconStyle}>
                        <FaEnvelope />
                    </a>
                    <a href={WHATSAPP_CTA} target="_blank" rel="noopener noreferrer" style={socialIconStyle}>
                        <FaWhatsapp />
                    </a>
                </div>

                {/* Contacto */}
                <p style={{ margin: '10px 0', fontSize: '1.1em' }}>
                    Contacto: <a href="mailto:VIMCARBROKER@GMAIL.COM" style={{ color: '#007bff', textDecoration: 'none' }}>VIMCARBROKER@GMAIL.COM</a>
                </p>
                <p style={{ margin: '5px 0' }}>
                    Teléfono: <a href={`tel:${WHATSAPP_NUMBER}`} style={{ color: '#007bff', textDecoration: 'none' }}>+1 (305) 407-6280</a>
                </p>
                
                {/* Copyright */}
                <div style={{ marginTop: '20px', paddingTop: '10px', borderTop: '1px solid #444' }}>
                    &copy; {new Date().getFullYear()} VimcarBroker. Todos los derechos reservados.
                </div>
            </div>
        </footer>
    );
}

// Estilos para los íconos sociales
const socialIconStyle = {
    color: 'white',
    fontSize: '24px',
    margin: '0 10px',
    transition: 'color 0.3s',
    textDecoration: 'none',
};